import FiguresTooltip from '../FiguresTooltip';
import { Tooltip } from 'antd';

const TwoPakerLayout = props => {
    const { research, scale, minDepth, width, title, date, toDepth } = props;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    const height = (bottom - roof) * scale + 16;

    // const realWidth = /^(\d+)px$/.exec(width)[1];
    const realWidth = width;

    return (
        <Tooltip
            title={<FiguresTooltip title={title} roof={roof} bottom={bottom} date={date} />}
            styles={{ root: { maxWidth: 'none' } }}
        >
            <svg
                width={realWidth}
                height={(bottom - roof) * 16 + 16}
                fill="none"
                style={{
                    position: 'absolute',
                    transform: `translateY(${Math.abs((minDepth - roof) * scale - scale + 8)}px)`,
                }}
            >
                <g>
                    <path
                        id="second_middle_line"
                        stroke="#7E8DA9"
                        d={`m8,${height - 8 - 12}l${realWidth - 12 - 6},0`}
                    />
                    <path
                        id="second_small_right_line"
                        stroke="#7E8DA9"
                        d={`m${realWidth - 3},${height - 8 - 12}l2,0`}
                    />
                    <path
                        id="right_long_line"
                        fill="#7E8DA9"
                        d={`m${realWidth - 9},${height}l0,40l-1,0l0,-${height}l1,0z`}
                    />

                    <path
                        id="right_rectangle"
                        stroke="#7E8DA9"
                        d={`m${realWidth - 9},${height - 24 - 8}l6,0l0,${24}l-6,0`}
                    />
                    <path id="svg_5" stroke="#7E8DA9" d={`m2,${height - 8 - 12}l-2,0`} />
                    <path id="left_long_line" fill="#7E8DA9" d={`m7.5,${height}l0,40l1,0l0,-${height}l-1,0z`} />
                    <path id="left_rectangle" stroke="#7E8DA9" d={`m8,${height - 24 - 8}l-6,0l0,${24}l6,0`} />

                    <path id="top_middle_line" stroke="#7E8DA9" d={`m8,20l${realWidth - 12 - 6},0`} />
                    <path id="top_right_small_line" stroke="#7E8DA9" d={`m${realWidth - 3},20l2,0`} />
                    <path id="right_top_line" fill="#7E8DA9" d={`m${realWidth - 9},0l0,40l-1,0l0,-40l1,0z`} />
                    <path id="right_top_rectangle" stroke="#7E8DA9" d={`m${realWidth - 9},8l6,0l0,24l-6,0`} />
                    <path id="svg_12" stroke="#7E8DA9" d="m2,20l-2,0" />
                    <path id="svg_13" fill="#7E8DA9" d="m7.5,0l0,40l1,0l0,-40l-1,0z" />
                    <path id="svg_14" stroke="#7E8DA9" d="m8,8l-6,0l0,24l6,0" />
                </g>
            </svg>
        </Tooltip>
    );
};

export default TwoPakerLayout;
